<template>
<div>
  <button
    ref="button"
    class="faceid-button"
    :style="{ bottom:positionNum + 'rem' }"
    data-toggle="modal" data-target=".bs-faceid-modal"
  >
  </button>
  <!-- 人脸识别 -->
  <div class="modal fade bs-faceid-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h1>{{ $t('imagewall.selfieTitle') }}</h1>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body">
          <avatar @selectSuccess="selectSuccess"></avatar>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Avatar from '@/components/avatar.vue'

export default {
  data: () => ({
  }),
  components: {
    Avatar
  },
  props: {
    positionNum: Number
  },
  methods: {
    selectSuccess (photos) {
      this.$emit('selectSuccess', photos)
    }
  }
}
</script>
